// extracted by mini-css-extract-plugin
export var deleteModal = "_g0-0";